export const manifest = {
  screens: {
    scr_6g0v2t: { name: "Home", route: "/", state: {"activeSection":"home"}, position: {"x":160,"y":220} },
    scr_8cispo: { name: "Creator Websites", route: "/", state: {"activeSection":"websites"}, position: {"x":1560,"y":220} },
    scr_2xy5bh: { name: "Hosting", route: "/", state: {"activeSection":"hosting"}, position: {"x":2960,"y":220} },
    scr_k7w4yf: { name: "Streaming", route: "/", state: {"activeSection":"streaming"}, position: {"x":4360,"y":220} },
    scr_wzr7kl: { name: "Pricing", route: "/", state: {"activeSection":"pricing"}, position: {"x":5760,"y":220} },
    scr_9ftef8: { name: "Promotion", route: "/", state: {"activeSection":"promotion"}, position: {"x":7160,"y":220} },
  },
  sections: {
    sec_v71oir: { name: "Website pages", x: 0, y: 0, width: 8520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_v71oir", children: [
      { kind: "screen", id: "scr_6g0v2t" },
      { kind: "screen", id: "scr_8cispo" },
      { kind: "screen", id: "scr_2xy5bh" },
      { kind: "screen", id: "scr_k7w4yf" },
      { kind: "screen", id: "scr_wzr7kl" },
      { kind: "screen", id: "scr_9ftef8" },
    ] },
  ],
}
